import { render, staticRenderFns } from "./warehouseGoodsClassifyList.vue?vue&type=template&id=b96669ca&"
import script from "./warehouseGoodsClassifyList.vue?vue&type=script&lang=js&"
export * from "./warehouseGoodsClassifyList.vue?vue&type=script&lang=js&"
import style0 from "./warehouseGoodsClassifyList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports